export const documentation = {
  junior: [
    { name: 'UI Design Guidelines', url: '/docs/ui-design-guidelines', type: 'guidelines' },
    { name: 'Visual Design Standards', url: '/docs/visual-design-standards', type: 'standards' },
    { name: 'Color Palette Usage', url: '/docs/color-palette', type: 'color' },
    { name: 'Typography Guidelines', url: '/docs/typography-guidelines', type: 'typography' },
    { name: 'Icon Design Standards', url: '/docs/icon-design', type: 'icons' }
  ],
  mid: [
    { name: 'Advanced UI Patterns', url: '/docs/advanced-ui-patterns', type: 'patterns' },
    { name: 'Component Design System', url: '/docs/component-design-system', type: 'components' },
    { name: 'UI Animation Guidelines', url: '/docs/ui-animation', type: 'animation' },
    { name: 'Responsive UI Design', url: '/docs/responsive-ui', type: 'responsive' },
    { name: 'Accessibility in UI Design', url: '/docs/ui-accessibility', type: 'accessibility' }
  ],
  senior: [
    { name: 'UI Design Leadership', url: '/docs/ui-design-leadership', type: 'leadership' },
    { name: 'Design System Architecture', url: '/docs/design-system-architecture', type: 'architecture' },
    { name: 'UI Design Operations', url: '/docs/ui-design-operations', type: 'operations' },
    { name: 'Cross-Platform UI Strategy', url: '/docs/cross-platform-ui', type: 'strategy' },
    { name: 'UI Innovation Framework', url: '/docs/ui-innovation', type: 'innovation' }
  ]
};
